export default "__VITE_ASSET__be4ee7e9__"